var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloud = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 10 16 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20 14c-.359 0-.699.073-1.019.189.006-.063.019-.124.019-.189a2 2 0 0 0-2-2c-.449 0-.859.153-1.192.403A3.49 3.49 0 0 0 12.5 10 3.5 3.5 0 0 0 9 13.5c0 .228.026.448.067.663A2.99 2.99 0 0 0 7 17a3 3 0 0 0 3 3h10a3 3 0 1 0 0-6"
})));
export default SvgCloud;